import { createSvgIcon } from "@material-ui/core";

export default createSvgIcon(
  <>
    <path
      d="M15,14.8c0.1,0,0.2,0.1,0.3,0.1l5.3,7c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1-0.1,0.2l-0.8,0.6c0,0-0.1,0-0.2,0
		c0,0-0.1,0-0.2-0.1l-4.7-7.6c-0.1-0.2-0.1-0.4,0.1-0.5C14.9,14.8,15,14.8,15,14.8 M15,13.8c-0.3,0-0.5,0.1-0.8,0.2l0,0
		c-0.6,0.4-0.8,1.2-0.4,1.9l4.8,7.4c0.2,0.4,0.6,0.6,1.1,0.6c0.2,0,0.5-0.1,0.7-0.2l0.8-0.6c0.6-0.4,0.7-1.2,0.3-1.9l-5.4-7
		C15.8,14,15.3,13.8,15,13.8L15,13.8z"
    />
    <path
      d="M9.6,1.1c2.2,0,4,1,5.3,2.8c2,2.8,1.3,7-1.6,8.8c-1.1,0.7-2.3,1.1-3.7,1.1c-2.2,0-4-1-5.3-2.8C2.3,8.2,3,4.2,6,2.2
		C7,1.4,8.3,1.1,9.6,1.1 M9.6,0C8.1,0,6.7,0.4,5.4,1.4C2,3.7,1.2,8.3,3.5,11.6c1.4,2,3.7,3.1,6.1,3.1c1.4,0,2.9-0.4,4.2-1.3
		c3.4-2.3,4.2-6.9,1.9-10.3C14.2,1.1,11.9,0,9.6,0L9.6,0z"
    />
    <path
      d="M7.3,4.1c1.5-1,3.4-1.1,4.3-0.2c0-0.1-0.1-0.2-0.2-0.3
	c-0.8-1.1-2.8-1.1-4.5,0S4.5,6.6,5.4,7.7C5.4,7.8,5.4,8,5.6,8C5.1,6.8,5.7,5.1,7.3,4.1z"
    />
  </>,
  "Search",
);
